import { EventEmitter, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Message } from 'primeng/message';

@Injectable({
  providedIn: 'root',
})
export class ToastHistoryService {
  private historyMessage: Message[] = [];
  private max = 10;
  messadeAdded: EventEmitter<void> = new EventEmitter<void>();

  constructor(private meassgeService: MessageService) {
    this.loadFromLocalStorage();
    this.subscribeToMessage();
  }
  private subscribeToMessage() {
    this.meassgeService.messageObserver.subscribe((message: any) => {
      if (!message) return;

      if (Array.isArray(message)) {
        message.forEach(m => this.add(m));
      }
      else {
        this.add(message);
      }
    })
  }

  private add(message: Message) {
    const messages: any = {
      ...message,
      unread: true
    };
    this.historyMessage.unshift(messages);
    this.historyMessage = this.historyMessage.slice(0, this.max);
    this.saveToLocalStorage();
    this.messadeAdded.emit();
  }

  getHistoryMessage(): Message[] {
    return this.historyMessage;
  }

  private saveToLocalStorage() {
    localStorage.setItem('toastMessageHistory', JSON.stringify(this.historyMessage))
  }
  private loadFromLocalStorage() {
    const data = localStorage.getItem('toastMessageHistory');
    if (data) {
      this.historyMessage = JSON.parse(data);
    }
  }
  markAllAsRead() {
    this.historyMessage = this.historyMessage.map((message: any) => ({
      ...message,
      unread: false
    }));
    this.saveToLocalStorage();
  }
}
